import React from 'react';

import NotificationPreferencesEditor from './NotificationPreferencesEditor';


const NotificationPreferences = () => {
    return <NotificationPreferencesEditor mode="self" />;
};


export default NotificationPreferences;